import PageHeader from "@/components/PageHeader";
import AmenitiesShowcase from "@/components/AmenitiesShowcase";
import EditorialMarquee from "@/components/EditorialMarquee";

export default function Amenities() {
    return (
        <div data-testid="page-amenities">
            <PageHeader
                eyebrow="Amenities — the daily rituals"
                title={<>Twelve amenities. <em className="italic text-lime">Zero excess.</em></>}
                lead="Every community is built around a fixed set of twelve daily amenities — chosen because they are used, not because they look good on a brochure."
            />
            <AmenitiesShowcase />
            <EditorialMarquee
                items={[
                    "Coach on request",
                    "Sun-lit atrium",
                    "Solar-heated pool",
                    "Silent library hours",
                    "Fibre backbone",
                    "24×7 concierge",
                ]}
            />
        </div>
    );
}
